import { type MessageInstance } from 'antd/es/message/interface';
import { type HookAPI } from 'antd/es/modal/useModal';
import { type Location, type NavigateFunction } from 'react-router-dom';

export const routerUtils = {
  navigate: (() => {}) as NavigateFunction,
  location: {} as Location,
};

export const messageUtils = {
  message: {} as MessageInstance,
};

export const modalUtils = {
  modal: {} as HookAPI,
};

export * from 'shared/utils/scroll';
